import Form from '@appComponents/ReduxFormControls';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import {UDP_ORIGIN_ENTRY_POINT} from '@constants/resources';
import {GetOptionsForForm, GetUdpOriginEntryPointForForm} from '@graphql/udpOriginEntryPoints/query';
import {
    CreateUdpOriginEntryPoint,
    DeleteUdpOriginEntryPoint,
    UpdateUdpOriginEntryPoint,
} from '@graphql/udpOriginEntryPoints/mutation';
import {adSupportSCTEField, adSpliceConfigField} from '@modules/adSplice/form/fieldsModel';
import {REQUIRE_THREE_LETTERS_PLACEHOLDER} from '@constants/variables';

import validate from './validator';
import {renderFormErrorMessages} from '../utils/modelHelpers';

export default function UdpOriginEntryPointModel() {
    return {
        entityDataMapKey: 'udpOriginEntryPoint',
        entityLabel: 'UDP origin entry point',
        formName: 'udpOriginEntryPoint',
        label: 'UdpOriginEntryPoint',
        resources: UDP_ORIGIN_ENTRY_POINT,
        showChangelog: true,
        validate: validate,
        title: null,
        dataMap: {
            udpOriginEntryPoint: {
                id: '',
                name: '',
                description: '',
                url: '',
                previewUrl: null,
                encodingDatacenter: {id: ''},
                failoverUdpOriginEntryPoint: {id: ''},
                tournaments: [],
                contentCategories: [],
                closeCaptioning: false,
                adSupport: false,
                adSpliceConfig: '',
            },
        },
        messages: {
            boxName: {
                delete: 'udpOriginEntryPointMessage',
                error: 'udpOriginEntryPointMessageError',
                success: 'udpOriginEntryPointMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                FORM_ERROR: renderFormErrorMessages,
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'udpOriginEntryPoint.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            name: {
                dataMapKey: 'udpOriginEntryPoint.name',
                props: {
                    component: Form.SemanticInput,
                    label: 'Name',
                    name: 'name',
                    required: true,
                    type: 'input',
                },
            },
            description: {
                dataMapKey: 'udpOriginEntryPoint.description',
                props: {
                    component: Form.SemanticInput,
                    label: 'Description',
                    name: 'description',
                    type: 'input',
                },
            },
            encodingDatacenters: {
                dataMapKey: 'udpOriginEntryPoint.encoding_datacenter.id',
                optionsKey: 'encodingDatacenters',
                props: {
                    allowClear: false,
                    component: Form.SemanticSelect,
                    label: 'Encoding datacenter',
                    name: 'encoding_datacenter',
                    placeholder: 'Select encoding datacenter',
                    required: true,
                },
            },
            url: {
                dataMapKey: 'udpOriginEntryPoint.url',
                props: {
                    component: Form.SemanticInput,
                    label: 'URL',
                    name: 'url',
                    required: true,
                    type: 'input',
                },
            },
            previewUrl: {
                dataMapKey: 'udpOriginEntryPoint.preview_url',
                props: {
                    component: Form.SemanticInput,
                    label: 'Preview URL',
                    name: 'preview_url',
                    type: 'input',
                },
            },
            closeCaptioning: {
                dataMapKey: 'udpOriginEntryPoint.has_cc',
                props: {
                    component: Form.SemanticInput,
                    label: 'Close Captioning',
                    name: 'has_cc',
                    type: 'toggle',
                },
            },
            adSupport: {
                dataMapKey: 'udpOriginEntryPoint.has_scte35',
                props: {
                    ...adSupportSCTEField('has_scte35'),
                },
            },
            adSpliceConfig: {
                dataMapKey: 'udpOriginEntryPoint.ad_splice_config.id',
                optionsKey: 'adSpliceConfigs',
                props: {
                    ...adSpliceConfigField('ad_splice_config'),
                },
            },
            failoverUdpOriginEntryPoint: {
                dataMapKey: 'udpOriginEntryPoint.failover_udp_origin_entry_point.id',
                optionsKey: 'udpOriginEntryPoints',
                props: {
                    allowClear: true,
                    component: Form.SemanticSelect,
                    label: 'Failover',
                    name: 'failover_udp_origin_entry_point',
                    placeholder: 'Select failover',
                },
            },
            tournaments: {
                dataMapKey: 'udpOriginEntryPoint.tournaments.id',
                props: {
                    allowClear: true,
                    component: Form.SemanticSelect,
                    label: 'Tournaments',
                    minCharacters: 3,
                    multiple: true,
                    name: 'tournaments',
                    placeholder: REQUIRE_THREE_LETTERS_PLACEHOLDER,
                },
            },
            contentCategories: {
                dataMapKey: 'udpOriginEntryPoint.content_categories.id',
                props: {
                    allowClear: true,
                    component: Form.SemanticSelect,
                    label: 'Content categories',
                    minCharacters: 3,
                    multiple: true,
                    name: 'content_categories',
                    placeholder: REQUIRE_THREE_LETTERS_PLACEHOLDER,
                },
            },
        },
        mutation: {
            createEntity: CreateUdpOriginEntryPoint,
            deleteEntity: DeleteUdpOriginEntryPoint,
            updateEntity: UpdateUdpOriginEntryPoint,
        },
        query: {
            getEntity: GetUdpOriginEntryPointForForm,
            getOptions: GetOptionsForForm,
        },
    };
}
